export default [
  {
    path: "/perpustakaan/turnitin",
    name: "perpustakaan-turnitin",
    component: () =>
      import("../../views/rektorat/perpustakaan/turnitin/Turnitin.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Perpustakaan", url: "/submenu/perpustakaan" },
        { title: "Turnitin", active: true },
      ],
      pageTitle: "Turnitin",
    },
  },
];
